import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { PartyOrderInsightsProps } from 'api/file/interfaces/get-file-order-insights';
import React from 'react';
import ClaimAlert from './components/ClaimAlert';
import PdfValidation from './components/PdfValidation';
import Sdn from './components/Sdn';
import Validation from './components/Validation';
import Watchlist from './components/Watchlist';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    w100: {
      width: '100%',
    },
  }),
);

const PartyOrderInsights: React.FC<PartyOrderInsightsProps> = ({ party, isPdf, index = 0, enableStatus }) => {
  const classes = useStyles();
  const shouldHideContactValidationSection = false;
  const shouldHideIdentityVerificationSection = false;

  return (
    <div className={classes.w100}>
      <Sdn party={party} isPdf={isPdf} />
      {party && party.filePartyType !== 'Lender' && (
        <>
          <Watchlist party={party} isPdf={isPdf} />
          <ClaimAlert party={party} isPdf={isPdf} />
          {(party.partyType === 'Individual' || party.partyType === 'A Married Couple') && !isPdf && (
            <>
              {enableStatus?.contactValidation !== undefined && !shouldHideContactValidationSection && (
                <Validation
                  party={party}
                  hasRisks={Boolean(party.contactValidation?.risks?.length)}
                  title="Contact Validation"
                  description={enableStatus.contactValidation.description}
                  isEnabled={enableStatus.contactValidation.enabled}
                  productCode={enableStatus.contactValidation.productCode}
                  qaPrefix={`contact-validation`}
                  index={index}
                />
              )}
              {enableStatus?.enhancedIdentityVerification !== undefined && !shouldHideIdentityVerificationSection && (
                <Validation
                  party={party}
                  hasRisks={Boolean(party.enhancedIdentifyVerification?.summary?.risks?.length)}
                  title="Identity Verification"
                  description={enableStatus.enhancedIdentityVerification.description}
                  isEnabled={enableStatus.enhancedIdentityVerification.enabled}
                  productCode={enableStatus.enhancedIdentityVerification.productCode}
                  qaPrefix={`identity-verification`}
                  index={index}
                  type="EnhancedIdentityVerification"
                />
              )}
            </>
          )}
          {(party.partyType === 'Individual' || party.partyType === 'A Married Couple') && isPdf && (
            <>
              <PdfValidation
                party={party}
                hasRisks={Boolean(party.contactValidation?.risks?.length)}
                title="Contact Validation"
                isEnabled={enableStatus?.contactValidation?.enabled}
              />
              <PdfValidation
                party={party}
                hasRisks={Boolean(party.enhancedIdentifyVerification?.summary?.risks?.length)}
                title="Identity Verification"
                type="EnhancedIdentityVerification"
                isEnabled={enableStatus?.enhancedIdentityVerification?.enabled}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default PartyOrderInsights;
